import 'moment';

class OrderSaveController {

    constructor($stateParams, ordersApiService, access) {
        this.$stateParams = $stateParams;
        this.ordersApiService = ordersApiService;
        this.access = access;
    }

    $onInit () {
        this.activeTab = this.$stateParams.tab || 'summary';
        this.preventEditing = ['Failed', 'Cancelled', 'Disputed'].indexOf(this.order.order_status) > -1;

        return Promise.all([
            this.ordersApiService.getOrderStatuses().then(response => {
                this.order_statuses = response.filter(status => {
                    return !status.private || status.id === this.order.order_status_id;
                });
            }),
            this.ordersApiService.getPaymentStatuses().then(response => {
                this.payment_statuses = response;
            })
        ]);
    }

    formatTime () {
        return moment(`${this.order.created_at}+00:00`).format('LLLL');
    }

    orderProgress (state) {
        switch (state) {
            case 'pendingPayment':
                return ['Pending payment', 'Awaiting Confirmation', 'Paid', 'Confirmed'].indexOf(this.order.order_status) > -1;
            case 'pendingConfirmation':
                return ['Awaiting Confirmation', 'Paid', 'Confirmed'].indexOf(this.order.order_status) > -1;
            case 'confirmed':
                return this.order.order_status === 'Confirmed';
            case 'cancelled':
                return ['Failed', 'Cancelled'].indexOf(this.order.order_status) > -1;
            case 'disputed':
                return this.order.order_status === 'Disputed';
        }
    }
}

OrderSaveController.$inject = ['$stateParams', 'ordersApiService', 'access'];

export default OrderSaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/controllers/order.save.controller.js